import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import {ReactComponent as LocationSVG} from '../assets/svgs/location.svg';
import {ReactComponent as EmailSVG} from '../assets/svgs/email.svg';
import {ReactComponent as PhoneSVG} from '../assets/svgs/phone.svg';
import MapModal from '../components/MapModal';   
import InlineMap from '../components/InlineMap';

// const ContactContainer = styled.div`
//   padding: 100px;
//   background-color: #fff;
//   border-radius: 10px;
//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//   width: fit-content;
//   max-width: 90vw;
//   // min-width: 300px;
//   margin: 80px 100px 100px;
//   place-self: center;
  

//   display: flex;
//   flex-direction: column;
//   gap: 30px;
//   text-align: left;

//   @media (max-width: 768px) {
//     text-align: center;
//     margin: 50px 50px 100px;
//     padding: 30px;
//   }
// `;

const ContactContainer = styled.div`
  padding: 40px 100px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  
  /* Make container take remaining width minus margins */
  width: calc(100% - 200px);  // 100% minus left+right margins
  max-width: 90vw;
  margin: 60px 100px 100px;
  place-self: center;

  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;

  @media (max-width: 768px) {
    width: calc(100% - 100px);  // adjust for smaller screens
    text-align: center;
    margin: 50px 50px 100px;
    padding: 30px;
  }
`;


const ContactTitle = styled.h2`
  color: #385963;
  font-weight: 600;
  text-align: center;
`;

const ContactGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  p {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    word-break: break-word;
    cursor: pointer;
    flex-direction:column;
  }

  strong {
    color: #385963;
  }

  svg {
    min-width: 25px;
  }

  @media (max-width: 768px) {
    gap: 20px;

    strong {
      font-size: 16px;
    }

    span {
      font-size: 14px;
    }

    p {
      flex-direction: column;
    }
  }
`;

const CopiedPopup = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #2ecc71;
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 14px;
  opacity: 0.95;
  z-index: 99999;
  animation: fadeOut 2s forwards;

  @keyframes fadeOut {
    0% { opacity: 0.95; }
    70% { opacity: 0.95; }
    100% { opacity: 0; }
  }
`;


const ContactInfo = () => {
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';

  const officePosition = [40.2677169412909, 22.51994311110853];

  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);

  const [copied, setCopied] = useState(false);

  const address =
    selectedLanguage === 'gr'
      ? '28ης Οκτωβρίου 40 (κτίριο Π.Ε. Πιερίας), 4ος όροφος'
      : "28is Oktovriou 40 (P.E. Pieria's Building), 4th floor";

  const openMap = () => {
    setSelectedPosition(officePosition);
    setShowMapModal(true);
  };

  const copyPhone = () => {
    navigator.clipboard.writeText("+30 2351 351 250");
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <ContactContainer>
      <ContactTitle>{i18n.t('contact')}</ContactTitle>

      <ContactGrid>

       

        {/* PHONE — copy on click */}
        <p onClick={copyPhone}>
          <PhoneSVG height={25} width={25} />
          <strong>{i18n.t('phone')}:</strong>
          <span style={{ textDecoration: 'underline', color: '#007bff' }}>
            +30 2351 351 250
          </span>
        </p>

        {/* EMAIL */}
        <p>
          <EmailSVG height={25} width={25} />
          <strong>{i18n.t('email')}:</strong>
          <a href="mailto:info@olympusrivieragreece.gr" style={{ color: '#007bff' }}>
            info@olympusrivieragreece.gr
          </a>
        </p>

         {/* ADDRESS — clickable */}
        <p onClick={openMap}>
          <LocationSVG height={25} width={25} />
          <strong>{i18n.t('address')}:</strong>
          <span style={{ textDecoration: 'underline', color: '#007bff' }}>
            {address}
          </span>
        </p>

     {/* <InlineMap  position={selectedPosition}/> */}
     <InlineMap position={officePosition} />
        

      </ContactGrid>

      {/* MAP MODAL
      {showMapModal && selectedPosition && (
        <MapModal
          position={selectedPosition}
          onClose={() => setShowMapModal(false)}
        />
      )} */}

      {/* COPIED POPUP */}
      {copied && <CopiedPopup>Copied!</CopiedPopup>}

    </ContactContainer>
  );
};

export default ContactInfo;
